import { html, LitElement, css, unsafeCSS } from 'lit';

import style from './menu.scss';

export class MenuComponent extends LitElement {

    constructor() {
        super();
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;
   
    render() {
        return html`
            <a class="button new" href="./cards">Cards</a>
            <a class="button new" href="./talents">Talents</a>
            <a class="button new" href="./builds">Builds</a>
            <a class="button new hidedesktop" href="./seeds">Seeds</a>
            <a class="button new hidedesktop" href="./events">Events</a>            
            <a class="button new" href="./challenges">Challenges</a>
            <a class="button new" href="./stats">Game Stats</a>
            <a class="button new" href="./speedruns">Speed Runs</a>
            <a class="button new" href="./highscores">High Scores</a>
            <a class="button new" href="./ladder">Ladder</a>
            <a class="button new" href="./halloffame">Hall of Fame</a>
            <a class="button new hidedesktop" href="./deck/create">Import Deck</a>
            <a class="button new hidedesktop" href="./build/create">Add a Build</a>
        `;
    }
}

customElements.define('menu-component', MenuComponent);